export default {
	validations: {
		required: "Value is required.",
		email: "Value is not a valid email address",
		minLength: "This field should be at least ${min} characters long",
		maxLength: "The maximum length allowed is ${max}",
		minValue: "The minimum value allowed is ${min}",
		maxValue: "The maximum value allowed is ${max}",
		numeric: "Value must be numeric",
		ipAddress: "The value is not a valid IP address",
		sameAs: "The value must be equal to the ${otherName} value",
	}
}